export default "__VITE_ASSET__BECawXfH__"